import { useContext, useEffect, useRef, useState } from 'react';
import RootStoreContext from '../../stores/root-store-context';
import { usePublishNotification } from '@yakoffice/notification-handler';
import type { IUser } from '../../model/user';
import { useParams } from 'react-router-dom';

interface useProjectUsersResult {
    isLoaded: boolean;
    users: IUser[];
    permissionDenied: boolean;
}

export const useProjectUsers = (callbackTrigger: number) => {

    const rootStore = useContext(RootStoreContext);
    const publishNotification = usePublishNotification();
    const { projectId } = useParams<{ projectId: string }>();
    const effectRan = useRef(false);

    const [result, setResult] = useState(() => ({
        isLoaded: true,
        users: [],
        permissionDenied: false
    } as useProjectUsersResult));

    const abortController = new AbortController();

    useEffect(() => {

        setResult({ isLoaded: false, users: [], permissionDenied: false });

        if (projectId != null) {
            rootStore.usersStore.loadUsersForProject(projectId)
                .then(() => {
                    setResult({ isLoaded: true, users: rootStore.usersStore.users, permissionDenied: false });
                    const signal = abortController.signal;
                })
                .catch(e => {
                        setResult({ isLoaded: true, users: [], permissionDenied: true });
                    }
                );
        }

        return () => {
            abortController.abort();
            effectRan.current = true;
        };

    }, [publishNotification, rootStore.usersStore, projectId, callbackTrigger]);

    return result;
};
